import { FileQuestion } from '@gravity-ui/icons';
import { useTranslation } from 'react-i18next';

/** 场景不存在或已删除。 */
export function SceneNotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-[#0a0a0a]">
      <div className="mx-4 flex max-w-sm flex-col items-center rounded-2xl bg-white/5 p-10 text-center backdrop-blur-md">
        <FileQuestion width={48} height={48} className="mb-4 text-white/40" />
        <h1 className="text-xl font-semibold text-white">{t('errors.scene-not-found')}</h1>
        <p className="mt-2 text-sm text-white/60">{t('errors.scene-not-found-desc')}</p>
      </div>
    </div>
  );
}
